module.exports = __webpack_public_path__ + "static/media/Sportler.fd6e9bc3.mp3";